import React from 'react';

const Loader = () => (
    <div id="loader-wrapper" className="loader-wrapper">
        <span>
            <p>pvqw</p>
            <div id="loader"></div>
            <p>loading</p>
        </span>  
    </div>
      
);

// setTimeout(() => {
//     document.getElementById('loader-wrapper').className = "hide";
// }, 3000);

export default Loader;


// WEBPACK FOOTER //
// ./src/components/Loader.js